import Avatar from 'funifier-nice-avatar';

interface DadosDeAvatar {
  avatar_type?: number;
  avatar?: unknown;
  image?: { small?: { url?: string }; medium?: { url?: string } };
}

interface AvatarDoRemetenteProps {
  dados?: DadosDeAvatar;
  nome?: string;
  /** Matrícula: escolhe a cor pastel, a mesma para a pessoa em qualquer lista. */
  matricula?: string;
}

const CORES = ['bg-brand-purple-light', 'bg-brand-green-light', 'bg-brand-pink-light', 'bg-brand-cyan-light'];

/** Primeira letra do primeiro e do último nome; uma letra só para nome de uma palavra. */
export function iniciais(nome?: string): string {
  const palavras = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  if (palavras.length === 0) return '';

  const ultima = palavras.length > 1 ? palavras[palavras.length - 1][0] : '';

  return `${palavras[0][0]}${ultima}`.toUpperCase();
}

export function corDoAvatar(matricula = ''): string {
  const soma = Array.from(matricula).reduce((total, letra) => total + letra.charCodeAt(0), 0);

  return CORES[soma % CORES.length];
}

const ANEL = 'shadow-[inset_0_0_0_2px_rgba(253,254,255,0.7)]';

/**
 * Avatar de 64px dos cartões de reconhecimento, como no Meu Perfil.dc.html:
 * foto quando a pessoa usa imagem, o avatar montado quando existe e, sem
 * nenhum dos dois, as iniciais sobre um círculo pastel.
 */
export default function AvatarDoRemetente({ dados, nome, matricula }: AvatarDoRemetenteProps) {
  const foto = dados?.avatar_type === 1 ? dados.image?.small?.url || dados.image?.medium?.url : undefined;

  if (foto) {
    return <img src={foto} alt="" className="h-16 w-16 shrink-0 rounded-full object-cover" />;
  }

  if (!dados?.avatar_type && dados?.avatar) {
    return (
      <span className="relative block h-16 w-16 shrink-0 overflow-hidden rounded-full">
        <Avatar style={{ width: 64, height: 64 }} {...(dados.avatar as object)} />
        <span aria-hidden="true" className={`pointer-events-none absolute inset-0 rounded-full ${ANEL}`} />
      </span>
    );
  }

  return (
    <span
      aria-hidden="true"
      className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-full font-display text-xl font-extrabold text-content ${ANEL} ${corDoAvatar(matricula)}`}
    >
      {iniciais(nome)}
    </span>
  );
}
